import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SchemaOrg from '@/components/feature/SchemaOrg';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import CategorySection from './components/CategorySection';
import PopularSection from './components/PopularSection';
import LatestSection from './components/LatestSection';
import NewsletterSection from './components/NewsletterSection';
import { useEffect } from 'react';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SchemaOrg
        type="WebSite"
        data={{
          name: '星球漫画',
          url: 'https://yzdaohc.cn',
          description: '星球漫画提供星际漫画、科幻漫画、宇宙漫画全集免费阅读，下拉式阅读体验。',
          inLanguage: 'zh-CN',
          potentialAction: {
            '@type': 'SearchAction',
            target: 'https://yzdaohc.cn/search?q={search_term_string}',
            'query-input': 'required name=search_term_string',
          },
        }}
      />
      <SchemaOrg
        type="Organization"
        data={{
          name: '星球漫画',
          url: 'https://yzdaohc.cn',
          description: '星球漫画 - 星际科幻漫画宇宙漫画大全',
          contactPoint: {
            '@type': 'ContactPoint',
            email: 'contact@xingqiumanhua.com',
            contactType: 'customer service',
            availableLanguage: ['Chinese'],
          },
        }}
      />
      <SchemaOrg
        type="WebPage"
        data={{
          name: '星球漫画 - 首页',
          description: '星球漫画提供星际漫画、科幻漫画、宇宙漫画全集免费阅读。',
          url: 'https://yzdaohc.cn',
          isPartOf: {
            '@type': 'WebSite',
            name: '星球漫画',
          },
        }}
      />

      <Navbar />
      <main>
        <HeroSection />
        <FeaturedSection />
        <CategorySection />
        <PopularSection />
        <LatestSection />
        <NewsletterSection />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}